import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Toaster } from './components/toaster';
import AccessGate from './components/AccessGate';
import AppRoutes from './routes';

function App() {
  return (
    <ThemeProvider>
      <AccessGate>
        <AuthProvider>
          <CartProvider>
            <AppRoutes />
            <Toaster />
          </CartProvider>
        </AuthProvider>
      </AccessGate>
    </ThemeProvider>
  );
}

export default App;
